import * as React from 'react';
import {
  useResolvedEntity,
  useConfigAppParams,
  getEffectiveEntityId,
  useConfigAppPath,
  useSearchParam,
} from '@web-config-app/core-react';
import { ErrorPage } from '@web-config-app/core-react-ui';
import { Box } from '@leagueplatform/genesis-core';

export const ConfigAppSettingsPage = () => {
  const params = useConfigAppParams();
  const { tabId, moduleId, childModuleId, environmentKey } = params;
  const { entity: domainEntity, isError: isEntityError } = useResolvedEntity({
    entityId: getEffectiveEntityId(params),
  });
  const generateConfigPaths = useConfigAppPath();
  const path = useSearchParam('path') ?? '';

  const { entityListPath } = generateConfigPaths({
    tabId,
    moduleId,
    childModuleId,
    environmentKey,
  });

  if (isEntityError || !environmentKey) {
    return <ErrorPage />;
  }

  if (!domainEntity) {
    return null;
  }

  return (
    <Box
      css={{
        fontFamily: 'monospace',
        typography: '$bodyTwo',
        whiteSpace: 'pre-wrap',
      }}
    >
      {JSON.stringify(
        {
          domainEntity,
          entityListPath,
          path,
        },
        null,
        2,
      )}
    </Box>
  );
};
